import { Routes } from '@angular/router';
import { routesAdminDadosEmpresa } from './routes_admin_dados_empresa';
import { routesAdminFinanceiro } from './routes_admin_financeiro';
import { routesAdminFiscal } from './routes_admin_fiscal';
import { routesAdminParametrizacao } from './routes_admin_parametrizacao';
import { routesAdminParceiro } from './routes_admin_parceiro';
import { routesAdminProduto } from './routes_admin_produto';
import { routesAdminVendas } from './routes_admin_vendas';

export const routesAdmin: Routes = [
  ...routesAdminParceiro,
  ...routesAdminParametrizacao,
  ...routesAdminProduto,
  ...routesAdminDadosEmpresa,
  ...routesAdminFinanceiro,
  ...routesAdminVendas,
  ...routesAdminFiscal
];
